import { normalAchievements } from "./normal-achievements";
import { secretAchievements } from "./secret-achievements";

export const achievements = {
  normal: normalAchievements,
  secret: secretAchievements
};
